// Angular
import { Component,inject } from '@angular/core';

//Services
import { AppConfigService } from '@core/services/config/app-config.service';

//Pipes
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

export interface PaymentMethod {
    id: string;
    name: string;
    img: string;
}

@Component({
  selector: 'app-payment-method',
  imports: [TranslatePipe],
  templateUrl: './payment-method.component.html',
  styleUrl: './payment-method.component.scss'
})
export class PaymentMethodComponent {

    appConfig = inject(AppConfigService)
        private createPaymentMethodConfig(id: string, name: string) {
        return {
            id,
            name,
            img: `${this.appConfig.imagePathPaymentsMethod()}${id}.webp`
        };
    }

    paymentMethods: PaymentMethod[] = [
        this.createPaymentMethodConfig('visa_icon', 'Visa'),
        this.createPaymentMethodConfig('mastercard_icon', 'Mastercard'),
        this.createPaymentMethodConfig('amex_icon', 'American Express'),
        this.createPaymentMethodConfig('paypal_icon', 'PayPal'),
        this.createPaymentMethodConfig('postepay_icon', 'Apple Pay'),
        this.createPaymentMethodConfig('stripe_icon', 'Google Pay'),
        this.createPaymentMethodConfig('klarna_icon', 'Klarna'),
        this.createPaymentMethodConfig('satispay_icon', 'Satispay'),
       
    ];


}
